import type { ComponentTheme } from '../types/component-theme';

import { ThemeVariants } from './constants/theme-variants';

export default {
    slots: {
        root: 'mx-auto flex w-full items-center justify-center gap-3 rounded-xl border text-center shadow-sm',
        icon: 'animate-spin text-(--accent-solid)',
        content: 'space-y-1',
        title: 'text-sm font-semibold',
        description: 'text-xs opacity-70'
    },
    variants: {
        compact: {
            true: {
                root: 'max-w-xs px-4 py-3'
            },
            false: {
                root: 'max-w-md flex-col px-5 py-6'
            }
        },
        theme: {
            [ThemeVariants.Dark]: {
                root: 'border-white/10 bg-white/5 text-slate-200'
            },
            [ThemeVariants.Light]: {
                root: 'border-slate-200 bg-white/80 text-slate-700'
            }
        }
    }
} satisfies ComponentTheme;
